/* BAM Awwwards Pack v2 - extracted from snippets/bam-awwwards.liquid 2026-08-26.
   Logic unchanged. Now loaded with defer instead of parsed inline in <head>.

   DO NOT replace the &nbsp; entity in SEPARATOR with a literal space. A plain
   ASCII space inside display:inline-block collapses to zero width and the
   headline renders as "Topbrands,onesupplier." This has regressed twice. */
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var isTouch = ('ontouchstart' in window) && navigator.maxTouchPoints > 0;

  /* Cursor spotlight removed 2026-06-11 - also clean up any existing dot */
  function removeCursorDot(){
    document.querySelectorAll('.bam-cursor').forEach(function(el){ el.remove(); });
  }

  /* SPLIT-TEXT REVEAL */
  function setupSplitText(){
    var headings = document.querySelectorAll(
      '.product__title, .product-information__title, .collection__title, ' +
      '[class*="hero"] h1, [class*="hero"] h2'
    );
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('is-revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0.2 }) : null;
    headings.forEach(function(h){
      if (h.dataset.bamSplit === '1') return;
      if (h.closest('footer, .bam-trust-strip')) return;
      /* FIX 2026-06-09: never split headings with child markup (<br>, <em>) - the split rebuilt them from plain text and destroyed line breaks ("BAM.Blanks" bug) */
      if (h.childElementCount > 0) return;
      var text = h.textContent.trim();
      if (!text || text.length > 80) return;
      var words = text.split(/\s+/);
      if (words.length > 10) return;
      /* The separator MUST be a non-breaking space. A plain space inside an
         inline-block collapses to zero width and the words run together. */
      var SEPARATOR = '<span class="bam-split__word bam-split__word--space" style="transition-delay:0ms">&nbsp;</span>';
      var html = '<span class="bam-split">' +
        words.map(function(w, i){
          var delay = (i * 60) + 'ms';
          return '<span class="bam-split__word" style="transition-delay:' + delay + '">' + w + '</span>';
        }).join(SEPARATOR) +
        '</span>';
      h.innerHTML = html;
      h.dataset.bamSplit = '1';
      var split = h.querySelector('.bam-split');
      if (!split) return;
      if (!io) { split.classList.add('is-revealed'); return; }
      /* QA FIX 2026-07-29: wait two frames so the hidden start state is
         painted before we observe. Observing immediately let the callback
         fire in the same frame the markup was written, which left the
         promoted layer stale and the heading blank until a scroll forced a
         repaint. */
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){ io.observe(split); });
      });
    });
  }

  /* QA FIX 2026-07-29: safety net. Anything still hidden once the page has
     settled gets revealed outright - a heading must never be invisible. */
  function revealStragglers(){
    document.querySelectorAll('.bam-split:not(.is-revealed)').forEach(function(split){
      var r = split.getBoundingClientRect();
      var inView = r.bottom > 0 && r.top < (window.innerHeight || 0);
      if (inView) split.classList.add('is-revealed');
    });
  }
  function forceAnyRemaining(){
    document.querySelectorAll('.bam-split:not(.is-revealed)').forEach(function(split){
      var r = split.getBoundingClientRect();
      var inView = r.bottom > 0 && r.top < (window.innerHeight || 0);
      if (inView) split.classList.add('bam-split--forced');
    });
  }

  /* 3D CARD TILT */
  function setupCardTilt(){
    if (isTouch) return;
    var cards = document.querySelectorAll('.product-card, .card-product, .product-grid__item, .collection-product-card');
    cards.forEach(function(card){
      if (card.dataset.bamTilt === '1') return;
      card.dataset.bamTilt = '1';
      card.setAttribute('data-bam-tilt', '');
      var rect = null;
      card.addEventListener('mouseenter', function(){ rect = card.getBoundingClientRect(); });
      card.addEventListener('mousemove', function(e){
        if (!rect) rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width;
        var y = (e.clientY - rect.top) / rect.height;
        var tiltX = (y - 0.5) * -5;
        var tiltY = (x - 0.5) *  5;
        card.style.transform = 'perspective(1000px) rotateX(' + tiltX + 'deg) rotateY(' + tiltY + 'deg) translateY(-3px)';
      });
      card.addEventListener('mouseleave', function(){ card.style.transform = ''; rect = null; });
    });
  }

  /* IMAGE REVEAL */
  function setupImageReveal(){
    if (!('IntersectionObserver' in window)) return;
    var imgs = document.querySelectorAll('[class*="hero"] picture img, [data-bam-reveal-img]');
    imgs.forEach(function(el){
      if (el.dataset.bamReveal === '1') return;
      el.dataset.bamReveal = '1';
      if (!el.hasAttribute('data-bam-reveal-img')) el.setAttribute('data-bam-reveal-img', '');
    });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('is-revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('[data-bam-reveal-img]:not(.is-revealed)').forEach(function(el){ io.observe(el); });
  }

  function init(){ removeCursorDot(); setupSplitText(); setupCardTilt(); setupImageReveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function(){ setupSplitText(); setupCardTilt(); setupImageReveal(); });

  window.addEventListener('load', revealStragglers);
  setTimeout(revealStragglers, 900);
  setTimeout(revealStragglers, 2000);
  setTimeout(forceAnyRemaining, 3500);

  /* Remove any stale marquee that earlier version injected */
  function cleanupMarquee(){
    document.querySelectorAll('.bam-marquee-statement').forEach(function(el){ el.remove(); });
  }
  cleanupMarquee();
  document.addEventListener('DOMContentLoaded', cleanupMarquee);
  setTimeout(cleanupMarquee, 500);
})();
